<template>
  <Page>
    <Table status-filter="sent_back" />
  </Page>
</template>

<script setup>

  import Page from "@/components/Page.vue";
  import Table from "./Table.vue";

</script>

<style scoped>

</style>